/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { hydrate, unmountComponentAtNode } from 'react-dom';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import Header from './Header';
import Footer from './Footer';
import OpenHouse from './OpenHouse';
import RegWall from './RegWall';
import reducer from '../../reducers';
import configureStore from '../../stores';
import fetchBackplane from '../../utils/fetchBackplane';
import './styles.scss';

const headerRoot = document.getElementById('backplane-header');
const openHouseModalRoot = document.getElementById('backplane-header-open-house');
const footerRoot = document.getElementById('backplane-footer');
const regWallRoot = document.getElementById('backplane-regwall');

const preloadedState = window.__BACKPLANE_API__; // eslint-disable-line no-underscore-dangle
const preloadedReduxState = window.__BACKPLANE_REDUX__; // eslint-disable-line no-underscore-dangle

const { wavetrakStore } = window;
let store;

// If there exists a store to merge, then perform the merge. If not create our own store here.
if (wavetrakStore) {
  store = wavetrakStore;
  wavetrakStore.injectReducer('backplane', reducer);
} else {
  if (!preloadedReduxState && process.env.NODE_ENV !== 'production') {
    console.warn(
      'Preloaded Redux state was not found: Backplane components ' +
        'will render without server side preloaded state',
    );
  }
  store = configureStore(preloadedReduxState);
}

const wrappedHydrate = (entrypointToWrap, rootToRenderTo) => {
  hydrate(
    <CookiesProvider>
      <Provider store={store}>{entrypointToWrap}</Provider>
    </CookiesProvider>,
    rootToRenderTo,
  );
};

const mount = () => {
  if (preloadedState) {
    wrappedHydrate(<Header {...preloadedState} />, headerRoot);
    wrappedHydrate(<Footer {...preloadedState} />, footerRoot);
    if (openHouseModalRoot) {
      wrappedHydrate(<OpenHouse {...preloadedState} />, openHouseModalRoot);
    }
    if (regWallRoot) {
      wrappedHydrate(<RegWall {...preloadedState} />, regWallRoot);
    }
  } else {
    fetchBackplane().then((backplane) => {
      wrappedHydrate(<Header {...backplane.data.api} />, headerRoot);
      wrappedHydrate(<Footer {...backplane.data.api} />, footerRoot);
      if (openHouseModalRoot) {
        wrappedHydrate(<OpenHouse {...backplane.data.api} />, openHouseModalRoot);
      }
      if (regWallRoot) {
        wrappedHydrate(<RegWall {...backplane.data.api} />, regWallRoot);
      }

      document.dispatchEvent(
        new CustomEvent('backplane_loaded', {
          detail: backplane.data.api,
        }),
      );
    });
  }
};

mount();

if (module.hot) {
  module.hot.accept(['./Header', './Footer', './OpenHouse', './RegWall'], () => {
    unmountComponentAtNode(headerRoot);
    unmountComponentAtNode(footerRoot);
    unmountComponentAtNode(openHouseModalRoot);
    unmountComponentAtNode(regWallRoot);
    mount();
  });
}
